import React from 'react'

import NotFoundPage from './pages/404'
import Home from './pages/home'
import ProfilePage from './pages/profile'
import Report from './pages/report'
import Support from './pages/support'

interface IRoutes {
  element: React.ReactNode
  secure?: boolean
  path: string
}

const routes: IRoutes[] = [
  {
    path: '/',
    secure: false,
    element: <Home />,
  },
  {
    path: '/profile',
    secure: true,
    element: <ProfilePage />,
  },
  {
    path: '/support',
    element: <Support />,
  },
  {
    path: '/report-card',
    element: <Report />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]

export default routes
